import { IValidationError, TError } from "../../models";

export class SimpleResult<T> {
  success = false;
  error?: TError;
  warn?: TError;
  errors?: IValidationError[];
  errorAdditionalDetails?: unknown;

  debugInfo?: unknown;
  data?: T;
  constructor(data?: Partial<SimpleResult<T>>) {
    Object.assign(this, data);
  }
}
